<template>
  <div class="table">
    <div class="table-header">
      <div class="table-row">
        <div class="cell sort cell-large center" @click="setSorting('rawmaterialID')">
          Serie
          <BaseIcon
            v-if="sortingOn == 'rawmaterialID'"
            :name="this.isAscending ? 'chevron-up' : 'chevron-down'"
            class="icon"
          />
        </div>
        <div class="cell sort cell-large center" @click="setSorting('ref')">
          REF
          <BaseIcon
            v-if="sortingOn == 'ref'"
            :name="this.isAscending ? 'chevron-up' : 'chevron-down'"
            class="icon"
          />
        </div>
        <div class="cell cell-medium center">Diameter</div>
        <div class="cell cell-big">Description</div>
        <LoadAmountList v-if="hasAmountDropdown" :totalItems="totalItems" @selectedAmount="selectedAmount" />
      </div>
    </div>
    <div class="table-content">
      <div
        class="table-row"
        v-bind:class="{'active-line-padding': selectedMat === mat}"
        v-for="(mat, index) in this.rawMats"
        :key="index"
        @click.stop="selectRow(mat)"
      >
        <div class="cell cell-large center">{{mat.rawMaterialID}}</div>
        <div class="cell cell-large center">{{mat.ref}}</div>
        <div class="cell cell-medium center">{{mat.diameter}}</div>
        <div class="cell cell-big">{{mat.description}}</div>
        <div class="cell">
          <BaseIcon
            name="comment"
            class="icon"
            size="lg"
            :class="{ 'light-grey': mat.comment == '' }"
          />
        </div>
        <div class="cell" @click.stop="openMenu(index)" >
          <BaseIcon name="ellipsis-h" class="icon grey" size="lg" />
        </div>
        <MoreTableActions 
          v-if="isOptionOpen && openOptions == index" 
          :locationMenu="index == 0 ? 'bottom' : 'top'" 
          @deleteRow="deleteRow"
          v-click-outside="closeMenu" 
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import MoreTableActions from "@/components/base/MoreTableActions";
import LoadAmountList from "@/components/base/LoadAmountList";

export default {
  components: {
    BaseIcon,
    MoreTableActions,
    LoadAmountList
  },
   
  props: {
    rawMats: {
      type: Array,
      required: true
    },
    hasAmountDropdown: {
      type: Boolean,
      default: true
    },
    totalItems: Number
  },
  mounted() {},
  data() {
    return {
      selectedMat: null,
      sortingOn: "rawmaterialID",
      isAscending: true,
      isOptionOpen: false,
      openOptions: ""
    };
  },
  methods: {
    selectedAmount(val) {
      console.log(val);
      this.$emit("selectedAmount", val);
    },
    selectRow(mat) {
      if (this.selectedMat != mat) {
        this.isOptionOpen = false;
      }
      this.selectedMat = mat;
      this.$emit("selectedRow", mat);
    },
    openMenu(index) {
      if (this.openOptions != index) {
        this.isOptionOpen = true;
      } else {
        this.isOptionOpen = !this.isOptionOpen;
      }
      this.openOptions = index;
    },
    closeMenu() {
      this.isOptionOpen = false
      this.openOptions = ''
    },
    deleteRow() {
      var that = this;
      this.$http
        .get(
          this.$endpoint +
            "management/rawmaterials/archive/" +
            this.selectedMat.rawMaterialID
        )
        .then(response => {
          this.isOptionOpen = false;
          this.openOptions = "";
          that.$emit("refresh", true);
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.$store
            .dispatch("logout")
            .then(() => this.$router.push("/login"))
            .catch(err => console.log(err));
          } else {
            that.$swal(
              'Oops that went wrong?',
              `Please contact the admin with the following info: ${ error }`,
              'error'
            );
          }
        });
    },
    setSorting(val) {
      if (this.sortingOn != val) {
        this.isAscending = true;
      } else {
        this.isAscending = !this.isAscending;
      }
      this.sortingOn = val;

      this.$emit("sorting", { on: this.sortingOn, asc: this.isAscending });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../style/base.scss";
@import "../style/components/tables.scss";
@import "@/style/components/active.scss";

.table-header {
  .table-row {
    .cell.sort {
      cursor: pointer;
    }
  }
}
</style>
